import { DocFlowSendingFieldName } from '../DocFlowSending.constants'
import {
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SAVE_TO_PROFILE,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_ADDITIONAL_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SAVE_TO_PROFILE,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_ADDITIONAL_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EMAIL,
} from '../DocFlowSendingCommunicationTable'

export const QA_NAME_DOC_FLOW_SENDING_EPOST_VALIDATION_ERRORS_REPORT_MODAL =
  'DocFlowEpostValidationErrorsReportModal'

export const DOC_FLOW_SENDING_EPOST_VALIDATION_ERRORS_REPORT_MODAL_NOTIFICATION_ID_EMPTY_COMMUNICATION =
  'docFlowEpostValidationErrorsReportModalEmptyCommunicationsNotification'

export const DOC_FLOW_SENDING_EPOST_VALIDATION_ERRORS_REPORT_MODAL_COLUMNS = {
  [DocFlowSendingFieldName.Email]: {
    width: 200,
  },
  [DocFlowSendingFieldName.Recipient]: {
    width: 312,
  },
  [DocFlowSendingFieldName.SaveToProfile]: {
    width: 200,
  },
  [DocFlowSendingFieldName.SendAdditionalEmail]: {
    width: 200,
  },
  [DocFlowSendingFieldName.SendEmail]: {
    width: 200,
  },
  [DocFlowSendingFieldName.SendEpost]: {
    width: 200,
  },
}

export const DOC_FLOW_SENDING_EPOST_VALIDATION_ERRORS_REPORT_MODAL_AVAILABLE_MASS_ACTIONS =
  [
    DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SAVE_TO_PROFILE,
    DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SAVE_TO_PROFILE,
    DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EMAIL,
    DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EMAIL,
    DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_ADDITIONAL_EMAIL,
    DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_ADDITIONAL_EMAIL,
  ]

export const DOC_FLOW_SENDING_EPOST_VALIDATION_ERRORS_REPORT_MODAL_NOTIFICATION_ID =
  'info'
